export default "__VITE_ASSET__FBKwqjgc__"